import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes";
import FreeCard from "./components/SidebarCard";
import { useEffect, useRef } from "react";
import VitalLogoSvg from "assets/img/logo/VitalLogo";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  onCloseSidebar?: () => void;
}) => {
  const { open, onClose, onCloseSidebar } = props;
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        window.innerWidth < 1024 &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        open
      ) {
        onCloseSidebar?.();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onCloseSidebar]);

  return (
    <div
      ref={sidebarRef}
      className={`sm:none duration-175 linear hide-scrollbar fixed !z-50 flex h-full flex-col overflow-y-auto bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "ltr:-translate-x-96 rtl:translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 z-50 block cursor-pointer xl:hidden ltr:right-4 rtl:left-4"
        onClick={onClose}
      >
        <HiX size={20} />
      </span>

      <div className="relative mt-2 flex items-center justify-center text-center text-white ltr:flex-row-reverse ltr:justify-end ltr:ps-4">
        <div
          className="relative mt-4 text-center text-navy-800"
          style={{ fontFamily: "'Great Vibes', cursive", fontSize: 35 }}
        >
          Vital<sup className="vital-sup">+</sup>
        </div>
        <div style={{ width: 70, height: 70 }}>
          <VitalLogoSvg />
        </div>
      </div>
      <div className="my-[10px] h-px bg-gray-300 dark:bg-white/30" />

      <ul className="mb-auto pt-1">
        <Links routes={routes} onClose={onClose} onLinkClick={onCloseSidebar} />
      </ul>

      {/* Free Horizon Card */}
      <div className="flex justify-center">
        <FreeCard />
      </div>
    </div>
  );
};

export default Sidebar;
